import axios from "axios";
import config from "../config";
import Cookies from "../components/cookies";

const cookie = new Cookies();
function getAuthHeaders() {
    const token = cookie.getCookie("access_token"); // always fresh
    return {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    };
}

export async function fetchEnvData(filters = {}) {
  let res = {};
  axios.defaults.baseURL = config.servers["base"];
  const urlToLoad = `/env-data/read/`;

  try {
    const response = await axios.post(
  urlToLoad,
  {
    project_name: filters.project_name || "",
    created_at_from: filters.created_at_from || "",
    created_at_to: filters.created_at_to || "",
    duration_days: filters.duration_days || "",
    context: filters.context || "",
    industry_type: filters.industry_type_list || [],
    location: filters.location || "",
    page: filters.page || 1,
    limit: filters.limit || 10,
  },
  {
    headers: getAuthHeaders(),
    withCredentials: true,
  }
);

    res = response.data;
    console.log("Fetched EnvData:", res);
    return res;
  } catch (error) {
    console.error("Fetch EnvData failed:", error);
    throw new Error("Failed to fetch environment data");
  }
}
export async function fetchScraperLogs() {
  let res = {};
  axios.defaults.baseURL = config.servers["base"];
  const urlToLoad = "/env-data/read/scraper-logs";

  try {
    const response = await axios.get(urlToLoad, {
      headers: getAuthHeaders(),
      withCredentials: true,
    });

    res = response.data;
    console.log("Fetched Scraper Logs:", res);
    return res;
  } catch (error) {
    console.error("Fetch Scraper Logs failed:", error);
    throw new Error("Failed to fetch scraper logs");
  }
}
export async function startScraping() {
  let res = {};
  axios.defaults.baseURL = config.servers["base"];
  const urlToLoad = "/env-data/generate_data"; 

  try {
    const response = await axios.post(
      urlToLoad,
      {},
      {
        headers: getAuthHeaders(),
        withCredentials: true,
      }
    );

    res = response.data;
    console.log("Start Scraping Response:", res);
    return res;
  } catch (error) {
    console.error("Start Scraping failed:", error);
    throw new Error("Failed to start scraping");
  }
}